module.exports = __webpack_public_path__ + "img/team_icn.90ecc0ce.svg";